<template>
    <div class="Card">
        <div class="Card__Head">
            <div class="Card__Head__Title">{{ $t('transactions') }}</div>
            <div class="Card__Head__CTA" v-on:click="transactionsCTAHandler()">{{ $t('see-all') }}</div>
        </div>
        <div class="Card__Content">
            <div class="Card__simple-table" v-if="getInvesmentsTransactionsLength >= 1">
                <div class="Card__simple-table__row" v-for="transaction in getInvestmentsTransactions">
                    <div class="left-side">
                        <img :src="transaction.bottlePicture" alt="" class="image">
                        <div class="heading-content">
                            <h2>{{ transaction.wine }}</h2>
                            <span>{{ $t(`${transaction.type}`) }}</span>
                        </div>
                    </div>
                    <div class="right-side">
                        <p>{{ transaction.total }}</p>
                        <span>{{ transaction.date }}</span>
                    </div>
                </div>
            </div>
            <div v-else>
                No data
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Transactions",
        props: ['getInvesmentsTransactionsLength', 'getInvestmentsTransactions'],
        methods: {
            transactionsCTAHandler() {
                this.$router.push(this.localePath({path: '/my-account/trade-history'}));
            }
        }
    }
</script>
